import { StrictMode, useEffect, useState } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import View from "./components/View.jsx";
import LeftBar from "./components/Leftbar.jsx";
import RightBar from "./components/Rightbarl.jsx";
import Cokies from "./cokies.js";
import texts from "./assets/texts/texts.js";

import { setAssetPath } from "@esri/calcite-components/dist/components";

import { defineCustomElements } from "@esri/calcite-components/dist/loader";

import "@esri/calcite-components/dist/calcite/calcite.css";
import "@arcgis/map-components/dist/components/arcgis-map";

import BaseMap from "./components/Basemap.jsx";
import Infopanel from "./widgets/leftpanel/Infopanel.jsx";

import {
  ServerHealthBanner,
  ServerHealthOverlay,
  ServerHealthProvider,
} from "./components/serverHelth.js";
/* setAssetPath("https://js.arcgis.com/calcite-components/3.3.0/assets"); */
defineCustomElements(window);
const cookies = new Cokies({
  acceptBtnText: texts.cookies.acceptBtnText,
  rejectBtnText: texts.cookies.rejectBtnText,
  mainText: texts.cookies.mainText,
});
function App() {
  const [view, setView] = useState(null);
  const [infoVisible, setInfoVisible] = useState(true);
  const [viewRedy, setViewRedy] = useState(false);
  useEffect(() => {
    if (viewRedy === false && view) {
      setViewRedy(true);
      view.view.when(() => {
      view.view.ui.add(cookies.elements.button.button, "bottom-right");
      })
    }
  },[view]);

  return (
    <>
      <ServerHealthBanner />
      <ServerHealthOverlay />
      <LeftBar onChange={setInfoVisible} view={view} />
      <div id="mapContainer">
        <View onChange={setView} />
        <BaseMap view={view} />
      </div>
      <RightBar view={view} />
      {infoVisible && <Infopanel onChange={setInfoVisible} />}
    </>
  );
}

// Mount the app
const root = createRoot(document.getElementById("root"));
root.render(
  <>
    <StrictMode>
      <ServerHealthProvider>
        <App />
      </ServerHealthProvider>
    </StrictMode>
  </>,
);
